import { CoreExecutorResult, } from "../../core/index.js";
import { DataPsmAssociationEnd } from "../model/index.js";
import { DataPsmExecutorResultFactory } from "./data-psm-executor-utils.js";
export async function executeDataPsmSetDematerialize(reader, createNewIdentifier, operation) {
    const resource = await reader.readResource(operation.dataPsmAssociationEnd);
    if (resource == null || !DataPsmAssociationEnd.is(resource)) {
        return DataPsmExecutorResultFactory.invalidType(resource, "data-psm association end");
    }
    return CoreExecutorResult.createSuccess([], [
        {
            ...resource,
            dataPsmIsDematerialize: operation.dataPsmIsDematerialized,
        },
    ]);
}
//# sourceMappingURL=data-psm-set-dematerialize-executor.js.map